import { Avatar, Body, Card } from '@e2n/ui/v2';
import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Abwesenheit } from '@/domain/mitarbeiter/features/rotationsplan/entities/Abwesenheit';

export function AbwesenheitCard({
  mitarbeiter,
  abwesenheit,
  lehrjahr,
  beruf,
}: {
  abwesenheit: Abwesenheit;
  mitarbeiter: Mitarbeiter;
  lehrjahr: string;
  beruf: Beruf;
}) {
  return (
    <Card>
      <div className="flex items-center gap-2">
        {mitarbeiter.imgUrl ? (
          <Avatar
            src={mitarbeiter.imgUrl}
            alt={mitarbeiter.getName()}
            fallbackInitials={mitarbeiter.getInitials()}
          />
        ) : (
          <Avatar type="initials" initials={mitarbeiter.getInitials()} />
        )}
        <div className="flex flex-col flex-1 gap-1 min-w-0">
          <Body className="truncate" weight="semibold">
            {mitarbeiter.vorname + ' ' + mitarbeiter.nachname}
          </Body>
          <Body className="text-labels-secondary truncate" size="sm">
            {lehrjahr + ' ⋅ ' + beruf.abkuerzung}
          </Body>
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-1">
          <FontAwesomeIcon
            className="size-3.5"
            icon={abwesenheit.abwesenheitsgrundIcon}
          />
          <Body size="sm" weight="semibold">
            {abwesenheit.grund}
          </Body>
        </div>
        <Body className="text-labels-secondary" size="sm">
          {abwesenheit.zeitraumLabel}
        </Body>
      </div>
    </Card>
  );
}
